export default "/_next/static/chunks/fonts/MaterialCommunityIcons-a7629910d13716b7080c4799ab771d7c.ttf";